// API base origin. Dev/prod: VITE_API_URL (e.g. https://api.asiacrypto.online).
// The WebSocket URL is derived from this in lib/ws.ts (http→ws, +/ws).
export const API_BASE = (import.meta.env.VITE_API_URL as string | undefined) || '/api';

/** Transport/RPC error. `status` mirrors the old HTTP codes (401 = auth) so the
 *  app's onAuthError logout path is unchanged. `code` is the server error code.
 *  Optional `data` carries safe structured detail (e.g. balance shortfall). */
export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    public data?: Record<string, unknown>,
  ) {
    super(code);
  }
}

/** Rpc / transport error code — works even when `instanceof ApiError` breaks across chunks. */
export function rpcErrorCode(e: unknown): string {
  if (e instanceof ApiError) return e.code;
  if (e && typeof e === 'object' && 'code' in e && typeof (e as ApiError).code === 'string') {
    return (e as ApiError).code;
  }
  if (e instanceof Error && e.message && e.message !== 'Error') return e.message;
  return '';
}
